import BootstrapVue from 'bootstrap-vue';
import VueRx from 'vue-rx';
import maskLoader from './extensions/mask-loader';
import skeletonLoader from './directives/skeleton-loader';
import buttonLoader from './directives/button-loader';

export default {
  install(Vue) {
    Vue.use(BootstrapVue);
    Vue.use(VueRx);

    Vue.directive('skeleton-loader', skeletonLoader);
    Vue.directive('button-loader', buttonLoader);

    maskLoader(Vue);
  },
};
